import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pedidoForm';
import FormatUtils from '../common/formatUtils/FormatUtils';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import DateFormat from '../common/dateFormat/DateFormat';
import Aguardando from '../common/template/aguardando';

import { 
	getListaComprovacao, alterarComprovacao, alterarImagemNfe, alterarImagemChecklist
} from './pedidoActions';
import { getLista as getListaPedidoPrazo } from '../pedidoPrazo/pedidoPrazoActions';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import { setError } from '../common/toast/toast';
import consts from '../consts';

class PedidoComprovacao extends Component {

	state = {
		linhaSelecionada: null,
	}

    componentWillMount() {
		this.props.getListaComprovacao();
		this.props.getListaPedidoPrazo();

		let idInterval = setInterval(() => {
			if (this.props.modoTela == 'lista') {
				this.props.getListaComprovacao();
				this.props.getListaPedidoPrazo();
			}
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});

		let initSeletorImagem = () => {
			const fileSelectorImagem = document.createElement('input');
			fileSelectorImagem.setAttribute('type', 'file');
			fileSelectorImagem.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {
						
						this.state.eventoImagem(reader.result);						

						initSeletorImagem();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorImagem = fileSelectorImagem;
		};

		initSeletorImagem();
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
    }

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'visualizacao' ? (
						<Form onSubmit={this.props.salvar} visualizacao />
					) : null}
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} visualizacao />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		return (
			<ContentCard>

				{this.modalComprovacao()}
			
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Data</Th>
								<Th alignCenter>Giro</Th>
								<Th alignCenter>Status</Th>
								<Th alignCenter>Motorista</Th>
								<Th alignCenter>Placa</Th>
								<Th alignCenter>Vendedor</Th>
								<Th alignCenter>Clientes</Th>
								<Th alignCenter>Km Início</Th>
								<Th alignCenter>Km Fim</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.listaComprovacao.map(item => (
								<Tr key={item.id}>
									<Td>{DateFormat.formatarDataSqlParaTela(item.data_pedido)}</Td>
									<Td alignCenter>{item.giro}</Td>
									<Td alignCenter>
										<span style={{ padding: 6, fontSize: 14 }} class={`badge badge-${item.km_fim_viagem ? 'success' : (item.km_inicio_viagem ? 'info' : 'warning')}`}>
											{item.km_fim_viagem ? 'Finalizada' : (item.km_inicio_viagem ? 'Em Trânsito' : 'Não Iniciada')}
										</span>
									</Td>
									<Td alignCenter>{item.nome_motorista}</Td>
									<Td alignCenter>{item.placa_veiculo}</Td>
									<Td alignCenter>{item.nome_usuario_inclusao}</Td>
									<Td alignCenter>{item.clientes}</Td>
									<Td alignCenter>{item.km_inicio_viagem ? FormatUtils.formatarValorTela(item.km_inicio_viagem, 0) : '-'}</Td>
									<Td alignCenter>{item.km_fim_viagem ? FormatUtils.formatarValorTela(item.km_fim_viagem, 0) : '-'}</Td>
									<Td alignRight minWidth={250}>
										<ButtonTable
											type={'success'}
											icon={'fas fa-check'}
											visible={true}
											event={() => {
												this.setState({
													...this.state,
													modalComprovacao: {
														...item,
														km_inicio_viagem: item.km_inicio_viagem ? FormatUtils.formatarValorTela(item.km_inicio_viagem, 0) : '',
														km_fim_viagem: item.km_fim_viagem ? FormatUtils.formatarValorTela(item.km_fim_viagem, 0) : ''
													}
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	modalComprovacao() {

		if (!this.state.modalComprovacao) {
			return null;
		}

		const registro = { ...this.state.modalComprovacao };

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Giro {registro.giro}</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalComprovacao: null, zoom: 100 })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>

							<Row>
								<Grid cols='12 12 12 12'>
									<Table responsive>
										<THead>
											<Tr>
												<Th>Cliente</Th>
												<Th alignCenter>Endereço</Th>
												<Th alignCenter>Produto</Th>
												<Th alignCenter>Quantidade</Th>
												<Th alignCenter colspan={2}>Foto NF-e</Th>
												<Th alignCenter colspan={2}>Foto Checklist</Th>
											</Tr>
										</THead>
										<TBody>
											{(registro.itens || []).map(item => {

												return (
													<Tr key={item.id}>
														<Td>{item.nome_cliente}</Td>
														<Td alignCenter>{item.nome_endereco}</Td>
														<Td alignCenter>{item.nome_produto}</Td>
														<Td alignCenter>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
														<Td width={10} alignCenter>
															<ButtonTable
																type={item.imagem_nfe ? 'success' : 'secondary'}
																icon={'fas fa-paperclip'}
																visible={true}
																event={() => {
																	if (item.imagem_nfe) {
																		window.open(`${consts.URL}/${item.imagem_nfe}`, '_blank');
																	} else {
																		setError('Foto da Nota Fiscal não foi anexada');
																	}
																}} />
														</Td>
														<Td width={10} alignCenter>
															<ButtonTable
																type={'primary'}
																icon={'fas fa-pencil-alt'}
																visible={true}
																event={() => {																	
																	this.setState({
																		...this.state,
																		eventoImagem: (base64) => {
																			if (base64) {
																				this.props.alterarImagemNfe({
																					...item,
																					imagem_nfe: base64
																				}, (imagem) => {
																					this.setState({
																						...this.state,
																						modalComprovacao: {
																							...registro,
																							itens: registro.itens.map(itemAux => {
																								if (itemAux.id == item.id) {
																									return {
																										...itemAux,
																										imagem_nfe: imagem
																									}
																								} else {
																									return itemAux;
																								}
																							})
																						}
																					});
																				});
																			}
																		}
																	});

																	this.fileSelectorImagem.click();
																}} />
														</Td>
														<Td width={10} alignCenter>
															<ButtonTable
																type={item.imagem_nfe ? 'success' : 'secondary'}
																icon={'fas fa-paperclip'}
																visible={true}
																event={() => {
																	if (item.imagem_nfe) {
																		window.open(`${consts.URL}/${item.imagem_checklist}`, '_blank');
																	} else {
																		setError('Foto do Checklist não foi anexada');
																	}
																}} />
														</Td>
														<Td width={10} alignCenter>
															<ButtonTable
																type={'primary'}
																icon={'fas fa-pencil-alt'}
																visible={true}
																event={() => {
																	this.setState({
																		...this.state,
																		eventoImagem: (base64) => {
																			if (base64) {
																				this.props.alterarImagemChecklist({
																					...item,
																					imagem_checklist: base64
																				}, (imagem) => {
																					this.setState({
																						...this.state,
																						modalComprovacao: {
																							...registro,
																							itens: registro.itens.map(itemAux => {
																								if (itemAux.id == item.id) {
																									return {
																										...itemAux,
																										imagem_checklist: imagem
																									}
																								} else {
																									return itemAux;
																								}
																							})
																						}
																					});
																				});
																			}
																		}
																	});

																	this.fileSelectorImagem.click();
																}} />
														</Td>
													</Tr>
												);
											})}
										</TBody>
									</Table>
								</Grid>
							</Row>

							<Row alignCenter>
								<LabelAndInputNumber
									label={'Km Inicial'}
									placeholder=''
									cols='12 4 4 4'
									casas={0}
									value={registro.km_inicio_viagem}
									onChange={data => {
										this.setState({
											...this.state,
											modalComprovacao: {
												...registro,
												km_inicio_viagem: data.target.value
											}
										});
									}} />

								<LabelAndInputNumber
									label={'Km Final'}
									placeholder=''
									cols='12 4 4 4'
									casas={0}
									value={registro.km_fim_viagem}
									onChange={data => {
										this.setState({
											...this.state,
											modalComprovacao: {
												...registro,
												km_fim_viagem: data.target.value
											}
										});
									}} />
								
								<LabelAndInputNumber
									label={'Distância'}
									placeholder=''
									cols='12 4 4 4'
									casas={0}
									readOnly='readOnly'
									value={parseInt(FormatUtils.formatarValorBanco(registro.km_fim_viagem)) - parseInt(FormatUtils.formatarValorBanco(registro.km_inicio_viagem))}
									onChange={data => {
										this.setState({
											...this.state,
											modalComprovacao: {
												...registro,
												km_fim_viagem: data.target.value
											}
										});
									}} />
							</Row>
							
							<Row alignCenter>
								<Grid cols='12 12 8 6'>
									<Button
										text={'Comprovar Documentação'}
										type={'success'}
										icon={'fa fa-chevron-left'}
										event={() => {
											if ((registro.itens || []).filter(pedidoItem => [1, 3].includes(pedidoItem.id_produto) && (!pedidoItem.imagem_nfe || !pedidoItem.imagem_checklist)).length) {
												setError('Fotos dos comprovantes são obrigatórias');
											} else if (parseInt(FormatUtils.formatarValorBanco(registro.km_fim_viagem)) - parseInt(FormatUtils.formatarValorBanco(registro.km_inicio_viagem)) <= 0){
												setError('Distância percorrida é inválida');
											} else {
												this.props.alterarComprovacao({
													...registro
												}, () => {
													this.setState({ ...this.state, modalComprovacao: null });
												});
											}
										}} />
								</Grid>
							</Row>
							
						</div>
						<div class=''>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.pedido.aguardando,
	modoTela: state.pedido.modoTela,
	listaComprovacao: state.pedido.listaComprovacao
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	getListaComprovacao, alterarComprovacao, alterarImagemNfe, alterarImagemChecklist, getListaPedidoPrazo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoComprovacao);
